import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import { useParams, useHistory } from "react-router-dom";

import clsx from "clsx";

import { makeStyles, Paper, Typography } from "@material-ui/core";

import ContactDrawer from "../ContactDrawer";
import MessageInput from "../MessageInput";
import TicketHeader from "../TicketHeader";
import TicketInfo from "../TicketInfo";
import TicketActionButtons from "../TicketActionButtonsCustom";
import MessagesList from "../MessagesList";
import api from "../../services/api";
import { ReplyMessageProvider } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { ForwardMessageProvider } from "../../context/ForwarMessage/ForwardMessageContext";

import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TagsContainer } from "../TagsContainer";
import { MotivoAtendimentoSelect } from "../MotivoAtendimentoSelect";
import UrgentToggleButton from "../UrgentToggleButton";
import { isNil } from 'lodash';
import { EditMessageProvider } from "../../context/EditingMessage/EditingMessageContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const drawerWidth = 320;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100%",
    position: "relative",
    overflow: "hidden",
  },

  mainWrapper: {
    flex: 1,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    boxShadow: theme.mode === "light"
      ? "0 4px 16px rgba(30, 20, 60, 0.10)"
      : "0 4px 16px rgba(0, 0, 0, 0.35)",
    marginRight: -drawerWidth,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },

  mainWrapperShift: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
}));

// ticketId (prop, opcional): permite reaproveitar este componente FORA
// da rota /tickets/:ticketId - ex: TicketViewModal (popup de ver
// conversa sem sair da tela atual, pedido do usuario 2026-09-29 na tela
// de Confirmação de Pendências). Sem a prop, continua lendo da URL como
// sempre (uso normal da pagina de tickets).
const Ticket = ({ ticketId: ticketIdProp }) => {
  const { ticketId: ticketIdFromRoute } = useParams();
  const ticketId = ticketIdProp || ticketIdFromRoute;
  const history = useHistory();
  const classes = useStyles();

  const { user, socket } = useContext(AuthContext);
  const { setTabOpen } = useContext(TicketsContext);


  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [contact, setContact] = useState({});
  const [ticket, setTicket] = useState({});
  const [organization, setOrganization] = useState(null);
  const [dragDropFiles, setDragDropFiles] = useState([]);
  const { companyId } = user;

  useEffect(() => {
    console.log("======== Ticket ===========")
    console.log(ticket)
    console.log("===========================")
}, [ticket])

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchTicket = async () => {
        try {

          if (!isNil(ticketId) && ticketId !== "undefined") {

            const { data } = await api.get("/tickets/u/" + ticketId);

            setContact(data.contact);
            // setWhatsapp(data.whatsapp);
            // setQueueId(data.queueId);
            setTicket(data);
            if (["pending", "open", "group"].includes(data.status)) {
              setTabOpen(data.status);
            }
            setLoading(false);
          }
        } catch (err) {
          // Dentro de um popup (ticketIdProp preenchido) nao faz sentido
          // navegar a pagina inteira pra /tickets - so' sai da tela onde
          // ja estava (ex: Confirmacao de Pendencias).
          if (!ticketIdProp) history.push("/tickets");   // correção para evitar tela branca uuid não encontrado Feito por Altemir 16/08/2023
          setLoading(false);
          toastError(err);
        }
      };
      fetchTicket();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [ticketId, user, history]);

  // Sistema/dominio do cliente, mostrado em destaque acima das tags
  // (pedido 2026-08-31: precisa aparecer sem precisar abrir o painel
  // lateral "Dados do contato").
  useEffect(() => {
    if (!contact?.id) {
      setOrganization(null);
      return;
    }
    let active = true;
    api.get(`/contacts/${contact.id}/organization-contacts`)
      .then(({ data }) => {
        if (active) setOrganization(data.organization || null);
      })
      .catch(() => {
        if (active) setOrganization(null);
      });
    return () => {
      active = false;
    };
  }, [contact?.id]);

  useEffect(() => {
    if (!ticket && !ticket.id && ticket.uuid !== ticketId && ticketId === "undefined") {
      return;
    }

    if (user.companyId) {
      //    const socket = socketManager.GetSocket();

      const onConnectTicket = () => {
        socket.emit("joinChatBox", `${ticket.id}`);
      }

      const onCompanyTicket = (data) => {
        if (data.action === "update" && data.ticket.id === ticket?.id) {
          setTicket(data.ticket);
        }

        if (data.action === "delete" && data.ticketId === ticket?.id) {
          if (!ticketIdProp) history.push("/tickets");
        }
      };

      const onCompanyContactTicket = (data) => {
        if (data.action === "update") {
          // if (isMounted) {
          setContact((prevState) => {
            if (prevState.id === data.contact?.id) {
              return { ...prevState, ...data.contact };
            }
            return prevState;
          });
          // }
        }
      };

      socket.on("connect", onConnectTicket)
      socket.on(`company-${companyId}-ticket`, onCompanyTicket);
      socket.on(`company-${companyId}-contact`, onCompanyContactTicket);

      return () => {

        socket.emit("joinChatBoxLeave", `${ticket.id}`);
        socket.off("connect", onConnectTicket);
        socket.off(`company-${companyId}-ticket`, onCompanyTicket);
        socket.off(`company-${companyId}-contact`, onCompanyContactTicket);
      };
    }
  }, [ticketId, ticket, history]);

  const handleDrawerOpen = useCallback(() => {
    setDrawerOpen(true);
  }, []);

  const handleDrawerClose = useCallback(() => {
    setDrawerOpen(false);
  }, []);

  const renderMessagesList = () => {
    return (
      <>
        <MessagesList
          isGroup={ticket.isGroup}
          onDrop={setDragDropFiles}
          whatsappId={ticket.whatsappId}
          queueId={ticket.queueId}
          channel={ticket.channel}
          ticketId={ticketId}
        >
        </MessagesList>
        <MessageInput
          ticketId={ticket.id}
          ticketStatus={ticket.status}
          ticketChannel={ticket.channel}
          droppedFiles={dragDropFiles}
          contactId={contact.id}
        />
      </>
    );
  };


  return (
    <div className={classes.root} id="drawer-container">
      <Paper
        variant="outlined"
        elevation={0}
        className={clsx(classes.mainWrapper, {
          [classes.mainWrapperShift]: drawerOpen,
        })}
      >
        {/* <div id="TicketHeader"> */}
        <TicketHeader loading={loading}>
          {ticket.contact !== undefined && (
            <div id="TicketHeader">
              <TicketInfo
                contact={contact}
                ticket={ticket}
                onClick={handleDrawerOpen}
              />
            </div>
          )}
          <TicketActionButtons
            ticket={ticket}
          />
        </TicketHeader>
        {/* </div> */}
        {organization && (organization.system || organization.domain) && (
          <Paper style={{ padding: "6px 12px", backgroundColor: "#fff8e1" }}>
            <span style={{ fontSize: 13, fontWeight: 600 }}>
              {organization.system && `Sistema: ${organization.system}`}
              {organization.system && organization.domain && " · "}
              {organization.domain && `Domínio: ${organization.domain}`}
            </span>
          </Paper>
        )}
        <Paper style={{ display: "flex", alignItems: "flex-start", gap: 8, flexWrap: "wrap", padding: 4 }}>
          <div style={{ flex: 1, minWidth: 220 }}>
            <TagsContainer contact={contact} />
          </div>
          {ticket.id && (
            <div style={{ width: 260 }}>
              <MotivoAtendimentoSelect ticket={ticket} />
            </div>
          )}
          {ticket.id && (
            <div style={{ alignSelf: "center" }}>
              <UrgentToggleButton ticket={ticket} />
            </div>
          )}
        </Paper>
        {ticket.status === "closed" && ticket.closingSummary && (
          <Paper
            variant="outlined"
            style={{ padding: 8, margin: "0 4px 4px 4px", backgroundColor: "#f5f5f5" }}
          >
            <Typography variant="caption" style={{ fontWeight: 700, display: "block", marginBottom: 2 }}>
              Resumo do atendimento (IA)
            </Typography>
            <Typography variant="body2" style={{ whiteSpace: "pre-line" }}>
              {ticket.closingSummary}
            </Typography>
          </Paper>
        )}
        <ReplyMessageProvider>
          <ForwardMessageProvider>
            <EditMessageProvider>
              {renderMessagesList()}
            </EditMessageProvider>
          </ForwardMessageProvider>
        </ReplyMessageProvider>
      </Paper>

      <ContactDrawer
        open={drawerOpen}
        handleDrawerClose={handleDrawerClose}
        contact={contact}
        loading={loading}
        ticket={ticket}
        organization={organization}
      />

    </div>
  );
};

export default Ticket;
